import React from 'react';
import { useDropzone} from 'react-dropzone';
import { Typography, Box,  IconButton, ListItem, ListItemText, List} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile'
import DeleteIcon from '@mui/icons-material/Delete'

const FileUploadComponent = ({ onFileSelect, selectedFile, onFileRemove}) => {
    const { getRootProps } = useDropzone({
        accept: {
            "application/pdf": [".pdf"],
            "application/msword": [".doc"],
            "text/plain": [".txt"],
          },
        onDrop: (acceptedFiles) => {
            onFileSelect(acceptedFiles)
        },
    });

    return (
        <Box>
            <Box
                {...getRootProps()}
                sx={{
                    boarder: '2px dashed gray',
                    padding: 2,
                    cursor: 'pointer',
                    textAlign: 'center',
                    color: '#ff0000'
                }}
                >
                    <Typography>
                            Click here to select the files(s) to attach
                            <UploadFileIcon sx={{ marginLeft: 1}} />
                        </Typography>
                </Box>
                <List>
                    {selectedFile && selectedFile.map((file, index) => (
                    <ListItem key={index} secondaryaction={
                    <IconButton onClick={()=> onFileRemove(file)}>
                        <DeleteIcon/>
                        </IconButton>
                    }>
                        <ListItemText primary={file.name}/>
                    </ListItem>
                    ))}
                    </List>
                </Box>
    )
};

export default FileUploadComponent;